export default function getReadStatusKeyName({invite_id_hash}) {
  return `invite-${invite_id_hash}-read`;
}
